module.exports = __webpack_public_path__ + "img/dialog-avatar.77cbd740.svg";